import { render, staticRenderFns } from "./AddEditItem.vue?vue&type=template&id=52476de1"
import script from "./AddEditItem.vue?vue&type=script&lang=js"
export * from "./AddEditItem.vue?vue&type=script&lang=js"
import style0 from "./AddEditItem.vue?vue&type=style&index=0&id=52476de1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports